import i18n from '@/lang/index'

export default [
  {
    permission: ['viewEx'],
    element: '#driver-item-abnormal',
    popover: {
      operate: {
        openMenu: 'exception'
      },
      title:  i18n.t('public.abnormal_info'),
      description: i18n.t('public.abnormal_step_desc_1'),
      side: 'left'
    }
  },
  {
    permission: ['viewEx'],
    element: '.driver-item-ex-handle',
    popover: {
      title: i18n.t('public.abnormal_handle'),
      description: i18n.t('public.carrier_step_desc_1')
    }
  },
  {
    permission: ['viewEx'],
    element: '.driver-item-ex-more',
    popover: {
      title: i18n.t('public.abnormal_handle'),
      description: i18n.t('public.abnormal_more_step_desc_2')

    }
  },
  {
    permission: ['viewEx'],
    element: '.driver-item-ex',
    popover: {
      title: i18n.t('public.abnormal_handle'),
      description: i18n.t('public.abnormal_all_step_desc_3')
    }
  }
]
